import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-doctors-filter d-flex",
      class: _setup.isMobile ? "flex-column" : "flex-row ga-4 align-center",
      attrs: { "data-qa": "lpu_doctors_list_filter" },
    },
    [
      _c(VSelect, {
        staticClass: "lpu-doctors-filter__select",
        class: { "lpu-doctors-filter__select--specialty": !_setup.isMobile },
        attrs: {
          items: _vm.specialities,
          "item-text": "name",
          "item-value": "id",
          "return-object": "",
          outlined: "",
          "hide-details": "",
          "persistent-placeholder": "",
          placeholder: _setup.tStatic("Специальность"),
          "append-icon": "ui-icon-arrow-down",
          "menu-props": _setup.selectMenuProps,
          "data-qa": "lpu_doctors_list_filter_speciality",
        },
        model: {
          value: _setup.filter.speciality,
          callback: function ($$v) {
            _vm.$set(_setup.filter, "speciality", $$v)
          },
          expression: "filter.speciality",
        },
      }),
      _vm._v(" "),
      !_setup.isMobile
        ? [
            _c(VSelect, {
              staticClass:
                "lpu-doctors-filter__select lpu-doctors-filter__select--experience",
              attrs: {
                items: _setup.experienceItems,
                "item-text": "name",
                "item-value": "value",
                outlined: "",
                "hide-details": "",
                "persistent-placeholder": "",
                placeholder: _setup.tStatic("Стаж"),
                "append-icon": "ui-icon-arrow-down",
                "menu-props": _setup.selectMenuProps,
                "data-qa": "lpu_doctors_list_filter_experience",
              },
              model: {
                value: _setup.filter.experience,
                callback: function ($$v) {
                  _vm.$set(_setup.filter, "experience", $$v)
                },
                expression: "filter.experience",
              },
            }),
            _vm._v(" "),
            _c(
              VBtnToggle,
              {
                staticClass: "lpu-doctors-filter__gender elevation-0",
                attrs: {
                  borderless: "",
                  "data-qa": "lpu_doctors_list_filter_gender",
                },
                model: {
                  value: _setup.selectedGender,
                  callback: function ($$v) {
                    _setup.selectedGender = $$v
                  },
                  expression: "selectedGender",
                },
              },
              [
                _c(
                  VBtn,
                  {
                    attrs: {
                      value: "M",
                      height: "48",
                      text: "",
                      "data-qa": "lpu_doctors_list_filter_gender_m",
                    },
                  },
                  [
                    _c("span", {
                      staticClass:
                        "ui-icon-gender-male ui-icon-fz-big primary--text",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  VBtn,
                  {
                    attrs: {
                      value: "F",
                      height: "48",
                      text: "",
                      "data-qa": "lpu_doctors_list_filter_gender_f",
                    },
                  },
                  [
                    _c("span", {
                      staticClass:
                        "ui-icon-gender-female ui-icon-fz-big special--text",
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "lpu-doctors-filter__home d-flex align-center px-4",
                attrs: {
                  role: "checkbox",
                  tabindex: "0",
                  "aria-checked": _setup.filter.isHomeCall,
                  "data-qa": "lpu_doctors_list_filter_home",
                },
                on: {
                  click: _setup.toggleHomeCall,
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _setup.toggleHomeCall.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _setup.toggleHomeCall.apply(null, arguments)
                    },
                  ],
                },
              },
              [
                _c(VCheckbox, {
                  staticClass:
                    "lpu-doctors-filter__home-checkbox ma-0 mt-0 pa-0",
                  attrs: {
                    "input-value": _setup.filter.isHomeCall,
                    "hide-details": "",
                    color: "primary",
                    tabindex: "-1",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "text-body-1" }, [
                  _vm._v(_vm._s(_setup.tStatic("Вызов на дом"))),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }